import PageHeader from "../../../Component/BasicComponents/HeaderBreadCrumbs";
import ExpenseTable from "./ExpenseTable";

type props = {};

const GradeMasterScreen = (props: props) => {
  return (
    <div className="p-4">
      <PageHeader
        title="Grade Master"
      />

      <div className="row mb-0 ">
        <div className="col-md-12">
          <ExpenseTable />
        </div>
      </div>
    </div>
  );
};
export default GradeMasterScreen;
